/* eslint-disable quote-props */
/* eslint-disable max-len */
import Question from '../../../models/Question';
import SlotTypes from '../../../models/SlotTypes';
import QuestionType from '../../../models/enums/QuestionType';
import SlotUnit from '../../../models/enums/SlotUnit';
import { etoileInitiatives } from '../../../models/SlotHelp.spec';

/* eslint-disable camelcase */

const question_pres_013: Question = {
  id: 'pres-013-liens-corridor-connectivite',
  oldId: '27',
  title: 'Nombre de liens végétal et/ou corridor de transit qui ont été créés dans l\'année',
  number: '2.13',
  description: ['Minimum de 500 m2, lien végétal minimum 20 m de largeur'],
  type: QuestionType.INDICATOR,
  frequency: 1,
  slots: [
    {
      type: SlotTypes.ETOILES,
      items: [''],
      data: ['0'],
      scoreCalculatedLater: false,
      optional: false,
      score: '0',
      scoringFct: (data:number) => {
        if (data >= 3) return 3;
        if (data >= 2) return 2;
        if (data >= 1) return 1;
        return 0;
      },
      maxScore: 3,
      help: etoileInitiatives,
      unit: SlotUnit.NUMBER_OF,
    },
  ],
};
const question_pres_013__v3: Question = {
  ...question_pres_013,
  number: '2.11',
};

export const question_pres_013_v2: Question = question_pres_013;
export const question_pres_013_v3: Question = question_pres_013__v3;
